import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { resolveInputOutline } from '../../../styles-system/input-element-utils.esm.js';
import { isFlatDesign } from '../../../themes/const.esm.js';

var textarea = {
  "default": function _default(theme, props) {
    var state = props.state,
      disabled = props.disabled,
      resize = props.resize,
      height = props.height,
      disableBorderEffect = props.disableBorderEffect;
    var isFlatDesign$1 = isFlatDesign(theme);
    return _objectSpread2(_objectSpread2({
      color: 'text',
      resize: resize,
      whiteSpace: 'normal',
      height: height,
      variant: 'scrollbar.text-area'
    }, disableBorderEffect ? {} : resolveInputOutline(theme, state ? state : 'muted', true, false, 2)), {}, {
      '&:focus:not(:read-only)': _objectSpread2({
        zIndex: '2'
      }, disableBorderEffect ? {} : resolveInputOutline(theme, state ? state : isFlatDesign$1 ? 'primary.moderate' : 'primary', false, disabled, 4)),
      '&:hover:not([disabled]):not(:focus):not(:read-only)': _objectSpread2({
        zIndex: '2'
      }, disableBorderEffect ? {} : resolveInputOutline(theme, state ? state : 'muted', true, disabled, 0.75)),
      '&[disabled]': {
        cursor: 'not-allowed',
        backgroundColor: 'neutrals.20',
        color: 'neutrals.13'
      },
      '&::placeholder': {
        color: 'neutral.darker'
      },
      '&:read-only': {
        cursor: 'text',
        backgroundColor: 'neutrals.20'
      }
    });
  }
};

export default textarea;
//# sourceMappingURL=variants.esm.js.map
